import * as z from "zod";

export const localizationSettingsSchema_ = z.object({
  enabled: z.boolean().nullish(),
});

export const localizationSettingsSchema: z.ZodType<LocalizationSettings> =
  localizationSettingsSchema_;
export interface LocalizationSettings extends z.infer<
  typeof localizationSettingsSchema_
> {}

/**
 * The single gate for localized customer-portal text. Nullish on team documents
 * written before the field existed, so it is compared rather than truthy-tested.
 */
export function localizationEnabled(
  localization: LocalizationSettings | null | undefined,
): boolean {
  return localization?.enabled === true;
}
